import { FormattedMessage } from 'react-intl';
import { SubTitle, Title } from '../../../Layout/Header/components/styles';

export default function FrontFooter() {
  return (
    <footer className="py-8 py-md-11 bg-gray-200">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-4 col-lg-3">
            <img src="/assets/images/logo.webp" alt="..." className="footer-brand img-fluid mb-2" />
            <p className="text-gray-700 mb-2">
              <div>
                <Title>
                  <FormattedMessage id="government_of_nepal" />
                </Title>
                <Title>
                  <FormattedMessage id="ministry_of_federal_afairs_and_general_administration" />
                </Title>
                <SubTitle>
                  <FormattedMessage id="provincial_and_local_goverment_support_program" />
                </SubTitle>
              </div>
            </p>
          </div>
          <div className="col-6 col-md-4 col-lg-2">
            <h6 className="fw-bold text-uppercase text-gray-700">
              <FormattedMessage id="front.footer_item.links" />
            </h6>
            <ul className="list-unstyled text-muted mb-6 mb-md-8 mb-lg-0">
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.org_mofaga" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.org_plgsp" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.org_kms" />
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-4 col-lg-2">
            <h6 className="fw-bold text-uppercase text-gray-700">
              <FormattedMessage id="front.footer_item.services" />
            </h6>
            <ul className="list-unstyled text-muted mb-6 mb-md-8 mb-lg-0">
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.services_documentation" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.services_support" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.services_contact" />
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="fw-bold text-uppercase text-gray-700">
              <FormattedMessage id="front.footer_item.provinces" />
            </h6>
            <ul className="list-unstyled text-muted mb-0">
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.province_1" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.province_2" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.province_3" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.province_4" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.province_5" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.province_6" />
                </a>
              </li>
              <li>
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.province_7" />
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-4 col-lg-3">
            <h6 className="fw-bold text-uppercase text-gray-700">
              <FormattedMessage id="front.footer_item.contact" />
            </h6>
            <ul className="list-unstyled text-muted mb-0">
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.org_address" />
                </a>
              </li>
              <li className="mb-3">
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.org_phone" />
                </a>
              </li>
              <li>
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.org_fax" />
                </a>
              </li>
              <li>
                <a href="#!" className="text-reset">
                  <FormattedMessage id="front.org_email" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
